import * as React from "react";

function SvgIcons8Unicast(props, ref) {
  return (
    <svg viewBox="0 0 32 32" {...{ ...props, ref }}>
      <path d="M16 5c-1.645 0-3 1.355-3 3 0 1.293.844 2.395 2 2.813V14h-4v6h2v-4h4v-5.188c1.156-.417 2-1.519 2-2.812 0-1.645-1.355-3-3-3zm0 2c.563 0 1 .438 1 1 0 .563-.438 1-1 1-.563 0-1-.438-1-1 0-.563.438-1 1-1zM4 21a1.999 1.999 0 100 4 1.999 1.999 0 100-4zm8 0a1.999 1.999 0 100 4 1.999 1.999 0 100-4zm8 0a1.999 1.999 0 100 4 1.999 1.999 0 100-4zm8 0a1.999 1.999 0 100 4 1.999 1.999 0 100-4z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Unicast);
